import { Row, Col, Button } from 'reactstrap';
import styles from './TabSections.module.scss';
import { useState } from 'react';
import Carousel from '../../../global/Components/Items/Carousel/Carousel';
import Product from '../../../global/Components/Items/Product/Product';


export default function TabSections(props) {
    const [currentTab, setCurrentTab] = useState(props.data[0].id);
    
    const handleTabClick = (e) => {
        setCurrentTab(e.target.id);
    }
  return (
    <>
        <Row className={styles.tab}>
            <Col xs={12} sm={10} md={10}>
                <div className={`mb-3 ${styles.tab}`}>
                    {/* <Button className={`me-2 ${currentTab == 'all' ? `${styles.active}` : ''}`} id={'all'}  onClick={handleTabClick}>
                        All
                    </Button> */}
                    {
                        props.data.map((item) => (
                            <Button key={item.id} className={`me-2 ${currentTab == item.id ? `${styles.active}` : ''}`} id={item.id}  onClick={handleTabClick}>
                                {item.title}
                            </Button>
                        ))
                    }
                </div>
            </Col>
            <Col xs={12} sm={2} md={2}>
                <div>
                    {/* arrow place */}
                </div>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <div>
                    {
                        currentTab === props.data[0].id && 
                        <Carousel arrow="top" key={props.data[0].id} align={'left'}>
                            {
                                props.data[0].products.map((product) => (
                                    <div className='ps-2' key={product.id}>
                                        <Product data={product} />
                                    </div>
                                    ))
                            }
                            
                        </Carousel>
                    }
                    {
                        props.data.map((item) => (
                            <div key={item.id} >
                                {  
                                    currentTab ===`${item.id}` &&
                                        <Carousel arrow="top" align={'left'}>
                                        
                                            {
                                                item.products.map((product) => (
                                                    <div className='ps-2' key={`${product.id}`}>
                                                        <Product data={product} />
                                                    </div>
                                                    ))
                                            }
                                        
                                        </Carousel>
                                }
                            </div>
                        ))
                    }
                </div>
            </Col>
        </Row>
    </>
  )
}
